import axios from './axios'



// 收银员列表
export function cashierList(data){
    return axios({
        url: 'sys/selectUserPage',
        method: 'post',
        data
   })
}
// 新增用户
export function addCashier(data){
    return axios({
        url: 'sys/registerUser',
        method: 'post',
        data
   })
}

// 编辑收银员回显
export function modifyCashier(data){
    return axios.get(`sys/${data}`)  
}

// 修改用户sys/delete
export function editCashier(data){
    return axios({
        url: 'sys/editUser',
        method: 'post',
        data
   })
}
// 删除用户
export function delCashier(data){
    return axios({
        url: 'sys/delete',
        method: 'post',
        data
   })
}